import React, { useContext, useEffect, useState } from "react";
// import PropTypes from "prop-types";
import clsx from "clsx";
import { Button, Form, Nav, Tab } from "react-bootstrap";
import { MediaTab } from "./MediaTab";
import { PriceTab } from "./PriceTab";
import { PublishTab } from "./PublishTab";
import { BasicTab } from "./BasicTab";
import { CurriculumTab } from "./CurriculumTab";
import styles from "./style/EditingCoursePage.module.css";

import { useEditingCourse } from "./hooks";
import { createContext } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCourseAction } from "@redux/actions";

const CourseContext = createContext();

const EditingCoursePage = () => {
  const dispatch = useDispatch();
  const editingCourse = useEditingCourse();
  const { editingCourse: course } = useSelector((state) => state.course);
  const { step, setStep, isUpdate } = editingCourse;

  const editingCourseTitle = isUpdate ? "Update Course" : "Create New Course";

  function checkDone(key, step) {
    if (step < key) {
      return styles.done;
    } else {
      return null;
    }
  }

  // useEffect(() => {
  //   let interval = null;
  //   if (editingCourse.autoSave && course.id) {
  //     interval = setInterval(() => {
  //       dispatch(updateCourseAction());
  //     }, 10000);
  //   } else {
  //     clearInterval(interval);
  //   }

  //   return () => {
  //     clearInterval(interval);
  //   };
  // }, [editingCourse.autoSave, course.id]);

  const handleSelectTab = (k) => {
    if (k < step) {
      setStep(Number(k));
    }
  };

  return (
    <div className="container pt-4">
      <CourseContext.Provider value={editingCourse}>
        <h5 className="mb-5">{editingCourseTitle}</h5>
        <Tab.Container onSelect={handleSelectTab} activeKey={step}>
          <Nav variant="pills" className={clsx(styles.steps, "d-flex mb-4")}>
            <Nav.Item className={clsx(checkDone(step, 1))}>
              <Nav.Link eventKey={1}>
                <span className={clsx(styles.number)}></span>
                <span className="step-name">Basic</span>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className={clsx(checkDone(step, 2))}>
              <Nav.Link eventKey={2}>
                <span className={clsx(styles.number)}></span>
                <span className="step-name">Curriculum</span>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className={clsx(checkDone(step, 3))}>
              <Nav.Link eventKey={3}>
                <span className={clsx(styles.number)}></span>
                <span className="step-name">Media</span>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className={clsx(checkDone(step, 4))}>
              <Nav.Link eventKey={4}>
                <span className={clsx(styles.number)}></span>
                <span className="step-name">Price</span>
              </Nav.Link>
            </Nav.Item>

            <Nav.Item className={clsx(checkDone(step, 5))}>
              <Nav.Link eventKey={5}>
                <span className={clsx(styles.number)}></span>
                <span className="step-name">Publish</span>
              </Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content className="mb-3">
            <Tab.Pane eventKey={1}>
              <BasicTab />
            </Tab.Pane>
            <Tab.Pane eventKey={2}>
              <CurriculumTab />
            </Tab.Pane>
            <Tab.Pane eventKey={3}>
              <MediaTab />
            </Tab.Pane>
            <Tab.Pane eventKey={4}>
              <PriceTab />
            </Tab.Pane>
            <Tab.Pane eventKey={5}>
              <PublishTab />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </CourseContext.Provider>
    </div>
  );
};

/* required: display name */
EditingCoursePage.displayName = "EditingCoursePage";

/* required: props types */
EditingCoursePage.propTypes = {};

/* required: default props */
EditingCoursePage.defaultProps = {};

export { EditingCoursePage, CourseContext };
